import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';
import { FiskalniRacuniClient, LpfrLicencaDropdownDto } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-licence-fiskalne-kase-multiselect',
  templateUrl: './licence-fiskalne-kase-multiselect.component.html',
  styleUrls: ['./licence-fiskalne-kase-multiselect.component.scss']
})
export class LicenceFiskalneKaseMultiselectComponent implements OnInit {

  /** Subs */
  private _subs : Subscription = new Subscription();

  /** Props */
  items: SelectItem[];
  selectedItems: LpfrLicencaDropdownDto[] = [];

  /** I/O */
  @Input() licenceFormArray: FormArray | AbstractControl;
  @Output() selectedLicence = new EventEmitter<LpfrLicencaDropdownDto[]>();

  constructor(private _client : FiskalniRacuniClient){}

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this.selectedItems = [...this.licenceFormArray.value.map((x) => x)];

    this._subs.add(
      this._client.getLicenceFiskalneKaseDropdown().subscribe((res)=>{
        this.items = res.data.map((x) => ({
          value: x,
          label: x.id,
        }));
      })
    );
  }

  selectedItemsOnChange() {
    this.selectedLicence.next(this.selectedItems);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
